/**
 * Query params for GenericCrudService.findAllPaginated on entity endpoints
 * (e.g. /clients/recipient/paginated). The API expects one options query param
 * whose value is JSON: search, select, where, etc. inside that object.
 */

/**
 * Builds filters for paginated entity lists used by gatewee-select-async.
 * search is nested inside options, not sent as flat options.search.
 */
export function buildPaginatedListFilters(
  listOptions?: Record<string, unknown>,
  search?: string,
): Record<string, unknown> {
  const options: Record<string, unknown> =
    listOptions && Object.keys(listOptions).length > 0 ? {...listOptions} : {};

  const trimmed = search?.trim();
  if (trimmed) {
    options['search'] = trimmed;
  }

  if (Object.keys(options).length === 0) {
    return {};
  }

  return {options};
}
